import { render, staticRenderFns } from "./FieldsTable.vue?vue&type=template&id=495a832c&scoped=true&"
import script from "./FieldsTable.vue?vue&type=script&lang=js&"
export * from "./FieldsTable.vue?vue&type=script&lang=js&"
import style0 from "./FieldsTable.vue?vue&type=style&index=0&id=495a832c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495a832c",
  null
  
)

export default component.exports